<template>
  <div class="filter-modal-wrapper small-filter-modal">
    <el-radio-group v-model="radios" class="radio-wrapper">
      <el-radio :label="2" class="radio">{{ $t('common.female') }}</el-radio>
      <el-radio :label="1" class="radio">{{ $t('common.male') }}</el-radio>
    </el-radio-group>

    <ModalButtons :reset="resetGender" :select="chooseGender" />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalButtons from '@/components/Common/FilterModalButtons'

export default {
  name: 'Gender',
  components: { ModalButtons },
  props: {
    genderVal: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      radios: null
    }
  },
  watch: {
    genderVal(val) {
      this.radios = val ?? null
    }
  },
  methods: {
    ...mapActions({
      setGender: 'search/SET_GENDER'
    }),
    chooseGender() {
      this.setGender(this.radios)
      this.$emit('clicked')
    },
    resetGender() {
      this.setGender(0)
      this.radios = null
    }
  }
}
</script>

<style scoped>
.radio-wrapper {
  display: flex;
  flex-direction: column;
  padding: 15px 0;
}
.radio {
  padding: 5px 0;
}
</style>
